module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container AdvisorsAdd"
  }, [_c('form', {
    staticClass: "h-adr"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("新規追加")]), _vm._v(" "), _c('advisor-form', {
    attrs: {
      "advisor": _vm.advisor,
      "watch": _vm.watch
    }
  }), _vm._v(" "), _c('btn', {
    staticClass: "u-btn u-btn--add",
    nativeOn: {
      "click": function($event) {
        return _vm.postAdvisor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v("ADを新規追加")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13501756"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Advisors/AdvisorsAdd.vue
// module id = 1294
// module chunks = 0